<script>
import { mapState, mapGetters } from 'vuex'
import { zendeskActions } from '@state/helpers'
import deepLink from '@/mixins/deeplink.js'

const GO_TO_HOME_ACTION = 'goToHome'

export default {
  name: 'Button',
  mixins: [deepLink()],
  props: {
    componentData: {
      type: Object,
      required: true,
    },
    full: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    ...mapState('zendesk', {
      fetching: state => state.fetching,
    }),
    ...mapState('widgets', {
      userOS: state => state.common.user.os,
      zendeskArticle: state => state.data.ZendeskArticle
    }),
    ...mapGetters('zendesk', ['validateSend']),
    ...mapGetters('widgets', ['notSatisfiedUser', 'userType']),
    computedToastMessages () {
      return this.validateSend.map(v => {
        return `
${v.message}\n`
      })
    },
    showButton () {
      if (
        this.userOS === 'unknown' &&
        this.componentData.action.type === GO_TO_HOME_ACTION
      )
        return false
      if (!this.notSatisfiedUser)
        return false
      return true
    },
  },
  methods: {
    ...zendeskActions,
    dispatchAction (name, userType) {
      if (name === GO_TO_HOME_ACTION) {
        const rappipayTag = this.zendeskArticle.tags.find(name => ['rappipay'].includes(name.toLowerCase()));
        const queryParam = rappipayTag ? 'goto=rappi_pay' : 'goto=home';
        this.callDeepLink(queryParam, userType)
      } else if (this.validateSend.length > 0) {
        this.computedToastMessages.forEach(m => {
          this.$noty.error(m, {
            timeout: 3000,
            layout: 'topCenter',
            progressBar: false,
            modal: true,
            theme: 'relax',
          })
        })
      } else {
        return this[name]()
      }
    },
  },
}
</script>

<template>
  <div
    v-if="showButton"
    :class="$style.buttonContainer"
  >
    <BaseButton
      :disabled="fetching"
      :class="[validateSend.length > 0 ? $style.disabled : '', $style.containerButton]"
      :full="full"
      @click="dispatchAction(componentData.action.type, userType)"
    >{{ componentData.text }}</BaseButton>
  </div>
</template>

<style scoped lang="scss" module>
@import '@design';
</style>
